import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import commonReducer, {
    commonApiSlice,
    initialState as commonInitialState,
} from "./common";
import jobsReducer, { jobsApiSlice } from "./jobs";
import modelReducer, {
    modelApiSlice,
    initialState as modelInitialState,
} from "./model";
import { pricingApiSlice } from "./pricing";
import { subscriptionListApiSlice } from "./subscription";
import userReducer, {
    userApiSlice,
    initialState as userInitialState,
} from "./user";
import userAuthReducer, {
    userAuthApiSlice,
    initialState as userAuthInitialState,
} from "./userAuth";

const userAuthFromStorage = localStorage.getItem("userAuth")
    ? JSON.parse(localStorage.getItem("userAuth") as string)
    : null;
const userInfoFromStorage = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo") as string)
    : null;

export const store = configureStore({
    reducer: {
        [userAuthApiSlice.reducerPath]: userAuthApiSlice.reducer,
        [userApiSlice.reducerPath]: userApiSlice.reducer,
        [jobsApiSlice.reducerPath]: jobsApiSlice.reducer,
        [commonApiSlice.reducerPath]: commonApiSlice.reducer,
        [modelApiSlice.reducerPath]: modelApiSlice.reducer,
        [pricingApiSlice.reducerPath]: pricingApiSlice.reducer,
        [subscriptionListApiSlice.reducerPath]:
            subscriptionListApiSlice.reducer,
        userAuth: userAuthReducer,
        jobs: jobsReducer,
        user: userReducer,
        common: commonReducer,
        model: modelReducer,
    },
    preloadedState: {
        userAuth: userAuthFromStorage
            ? { ...userAuthFromStorage }
            : userAuthInitialState,
        user: userInfoFromStorage
            ? { ...userInfoFromStorage, is_agency: userInfoFromStorage?.agency }
            : userInitialState,
        common: commonInitialState,
        model: modelInitialState,
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat(
            userAuthApiSlice.middleware,
            userApiSlice.middleware,
            commonApiSlice.middleware,
            modelApiSlice.middleware,
            jobsApiSlice.middleware,
            pricingApiSlice.middleware,
            subscriptionListApiSlice.middleware
        );
    },
});

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
